import { render, staticRenderFns } from "./ProductPagination.vue?vue&type=template&id=2f7fc43b&scoped=true"
import script from "./ProductPagination.vue?vue&type=script&lang=js"
export * from "./ProductPagination.vue?vue&type=script&lang=js"
import style0 from "./ProductPagination.vue?vue&type=style&index=0&id=2f7fc43b&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f7fc43b",
  null
  
)

export default component.exports